// extracted by mini-css-extract-plugin
export default {"logoImg":"VendorApp_logoImg__xfDkv","logoTxt":"VendorApp_logoTxt__IRyum"};